import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchStacksArgs, SearchStacksOutput, Stack, StackConnection } from "types/generated";

export type SearchStacksForNavigationItem = Pick<Stack, "id" | "name" | "spaceDetails">;

export type SearchStacksForNavigationData = {
  searchStacks: {
    edges: Array<{
      node: SearchStacksForNavigationItem;
      cursor: StackConnection["cursor"];
    }>;
    pageInfo: Pick<SearchStacksOutput["pageInfo"], "hasNextPage" | "endCursor">;
  };
};

export const SEARCH_STACKS_FOR_NAVIGATION: TypedDocumentNode<
  SearchStacksForNavigationData,
  QuerySearchStacksArgs
> = gql`
  query SearchStacksForNavigation($input: SearchInput!) {
    searchStacks(input: $input) {
      edges {
        node {
          id
          name
          spaceDetails {
            id
            name
            accessLevel
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
